import {formSpacing} from '../UI/forms/styles.js'

// The label components take their look from here. Change a value here instead of in a component.

export const labelStartPickerStyle = {
    // Above the picker, below the popup text
    paddingTop: 30,
    // Below the picker. The inputs block of a Popup adds rowGap below it, the total stays 60 as in PrintPopup.
    marginBottom: 60 - formSpacing.rowGap,
    // Between the title and the sheet
    titleGap: 12,
    // One label on the sheet, a 10x21 label stands upright
    label: {
        landscape: {width: 150, height: 100},
        portrait: {width: 100, height: 150}
    }
}

/** The A4 sheets with several labels: how many, upright or not, and the width that wraps them into their grid */
export const labelSheets: Record<string, {labels: number, portrait: boolean, maxWidth: number}> = {
    // 4x A6 in two rows of two
    A4: {labels: 4, portrait: false, maxWidth: 302},
    // 3x 10x21 next to each other
    A410x21: {labels: 3, portrait: true, maxWidth: 303},
    // 2x A5 above each other
    A4A5: {labels: 2, portrait: false, maxWidth: 151}
}
